import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import DiscountCodesEditForm from './DiscountCodesEditForm';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchDiscountCode } from 'store/actions/discountCodes/fetchDiscountCodes';
import { updateDiscountCode } from 'store/actions/discountCodes/updateDiscountCodes';
import utils from 'helpers/utils';

class DiscountCodesEditContainer extends React.Component {
    handleSubmitForm = (formValues) => {
        const {
            data,
            discountId,
            dispatchForm,
            history,
            id,
        } = this.props;

        const values = { ...formValues };

        if (values.percentage) {
            values.percentage = parseFloat(values.percentage) / 100;
        }

        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push(`/discounts/${ discountId }/discount-codes`));
                },
                values: utils.diffObjects(data, values),
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            discountId,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.discounts.title'),
                link: '/discounts',
            },
            {
                label: translate('resources.discount_codes.title'),
                link: `/discounts/${ discountId }/discount-codes`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.discount_codes.actions.edit', { title: data.token }) } />

                    <Actions>
                        <ListButton url={ `/discounts/${ discountId }/discount-codes` } />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <DiscountCodesEditForm
                            data={ data }
                            form='discounts_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

DiscountCodesEditContainer.propTypes = {
    data: PropTypes.object,
    discountId: PropTypes.number.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            payload.values = Object.assign({}, payload.values);

            if (payload.values.percentage) {
                delete payload.values.amount;
                delete payload.values.currency;
            } else {
                delete payload.values.percentage;
            }

            if (payload.values.expiry_date) {
                payload.values.expiry_date = `${ payload.values.expiry_date.substr(0, 10) } 23:59:59`;
            }

            dispatch(updateDiscountCode(payload));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchDiscountCode,
        resource: 'discount-codes',
    })
);

export default enhance(DiscountCodesEditContainer);



// WEBPACK FOOTER //
// ./src/pages/discountCodes/edit/DiscountCodesEditContainer.js